<template>
  <f7-page>
    <div>
      <div>
        <complaintDetails />
      </div>
    </div>
  </f7-page>
</template>

<script>
import ComplaintDetails from '@/components/ComplaintManagement/ComplaintDetails/index.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    ComplaintDetails,
  },
  data() {
    return {
      customStore: null,
    };
  },
  computed: {
    urlName() {
      return this.lastRouteHome ? 'Home' : 'ComplaintManagement';
    },
    ComplaintDetails() {
      return this.complaintDetails;
    },
    ComplaintFiles() {
      return this.complaintFiles;
    },
    ...mapState('filter', ['currentSampleId']),
    ...mapState('samples', ['lastRouteHome']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('complaintManagementDetails'),
        disabled: false,
        page: 'ComplaintManagementDetails',
        active: true,
      },
    ]);
    this.setCurrentFilter('ComplaintManagementDetails');
  },
  methods: {
    setSelectedIndex(e) {
      if (e.name === 'selectedIndex') {
        this.selectedRoute = e.value;
      }
    },
    setPriceAlert() {
      this.priceAlert = true;
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
  },
};
</script>

<style lang="sass" src="./complaint-details.scss"></style>
